// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__CB91k","title":"Images45_title__P8X9m","images":"Images45_images__39Hwm"};